import { render, staticRenderFns } from "./newproduct-detail.vue?vue&type=template&id=7b2b876e&scoped=true&"
import script from "./newproduct-detail.vue?vue&type=script&lang=js&"
export * from "./newproduct-detail.vue?vue&type=script&lang=js&"
import style0 from "./newproduct-detail.vue?vue&type=style&index=0&id=7b2b876e&prod&lang=stylus&scoped=true&"
import style1 from "./newproduct-detail.vue?vue&type=style&index=1&id=7b2b876e&prod&lang=stylus&"
import style2 from "./newproduct-detail.vue?vue&type=style&index=2&id=7b2b876e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b876e",
  null
  
)

export default component.exports